import { render, staticRenderFns } from "./q-item.vue?vue&type=template&id=77efde73&"
import script from "./q-item.vue?vue&type=script&lang=js&"
export * from "./q-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports